import { useMemo } from 'react';
import type { AppPerfMarker, PerfMarker } from '../types';

export interface ChatHistoryPerfMarkers {
  conversationsPerfMarker?: PerfMarker;
  deletePerfMarker?: PerfMarker;
  renamePerfMarker?: PerfMarker;
  resumePerfMarker?: PerfMarker;
}

export const useChatHistoryPerfMarkers = (appPerfMarker?: AppPerfMarker): ChatHistoryPerfMarkers => {
  const conversationsPerfMarker = useMemo(() => appPerfMarker?.createChild('AdsCopilotChatHistoryConversations'), [appPerfMarker]);
  const deletePerfMarker = useMemo(() => appPerfMarker?.createChild('AdsCopilotChatHistoryDelete'), [appPerfMarker]);
  const renamePerfMarker = useMemo(() => appPerfMarker?.createChild('AdsCopilotChatHistoryRename'), [appPerfMarker]);
  const resumePerfMarker = useMemo(() => appPerfMarker?.createChild('AdsCopilotChatHistoryResume'), [appPerfMarker]);

  return {
    conversationsPerfMarker,
    deletePerfMarker,
    renamePerfMarker,
    resumePerfMarker,
  };
};
